import Axios from 'axios'
import https from 'https'

export default {
  methods: {
    /**
     * Submit form data to the backend API
     */
    submit () {
      // Set app status and emit event
      this.$emit('submit-request')
      this._setState('submit-request')

      // Re-initialize the response
      this.response = {}

      // Let each field validate
      let validationPromises = this.getFields().map(field => field.validate())
      Promise.all(validationPromises).then(validationResults => {
        // The validation promises resolve to false if the field is invalid
        // Filter all true (valid) results and see if any false values left
        validationResults = validationResults.filter(x => !x)
        if (validationResults.length) {
          this.scrollToFirstError()

        // ////////////////////////////////////////////////////
        // Submit
        // ////////////////////////////////////////////////////
        } else {
          if (this.customSubmit) {
            this.customSubmit()
          } else {
            this._submitToRf()
          }
        }
      })
    },
    _submitToRf () {
      this._setState('busy')
      // Prepare the xhr request
      this.request.data = this._prepareFieldData()
      this.request.serviceTitan = this.serviceTitan
      this.request.serviceTitanData = this.serviceTitan ? this.prepareServiceTitanData() : null

      // Log the request
      this.$log('Request', this.request)
      this.$log('Raw JSON', JSON.stringify(this.request))

      Axios.post(this.submitTo, this.request, {
        headers: {
          'Rocket-Forms-Request-Key': this.requestKey,
          'Rocket-Forms-Form-Id': this.formId
        },
        // Ignore cert errors
        httpsAgent: new https.Agent({ rejectUnauthorized: false })
      })
      // ////////////////////////////////////////////////////
      // Success
      // ////////////////////////////////////////////////////
      .then(response => {
        this._afterSubmit(response)
      })
      // ////////////////////////////////////////////////////
      // Error
      // ////////////////////////////////////////////////////
      .catch(error => {
        this._setState('default')
        this.request = error.config
        this.response = error.message
        // update form status
        // display form status error
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          this.$error(error.response.data)
          this.response = error.response
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser
          this.$error('Request', error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          this.$error('Error', error.message)
        }

        // Report error to Rollbar
        this._report('error', 'Rocket Forms Submission Error', { request: this.request, response: this.response })
      })
    },
    _afterSubmit (response) {
      this.$log('Response', response)
      this.response = response
      this._setState('form-submitted')
      if (this.afterSubmit) {
        this.afterSubmit(response)
      } else {
        if (this.redirectTo && this.redirect) {
          // Clean up vm
          this.$destroy()
          // Redirect
          window.location.href = this.redirectTo
        } else {
          // reset form state to default? is this needed?
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/form/submit.js